import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import PageTopTitle from "../../shared/PageTopTitle"
import Button from "../../shared/button/Button"
import { updateCurrentFerryList } from "../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1200px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 1100px;
            height: auto;
            display: flex;
            justify-content: center;
            padding: 20px;
            gap: 40px;

            .side{
                width: calc(33% - 20px);
                display: flex;
                flex-direction: column;
                min-height: 300px;


                .title{
                    width: 100%;
                    padding: 12px;
                    border-radius: 5px;
                    background-color: ${({ theme }) => theme.secondaryBgColor};
                    margin-bottom: 10px;
                }

                .list{
                    display: flex;
                    flex-direction: column;
                    gap: 10px;


                    .item{
                        padding: 10px;
                        border: 1px solid ${({ theme }) => theme.mainBorderColor};
                        border-radius: 5px;
                        cursor: pointer;
                        font-weight: var(--font-weight-md);

                        &:hover{
                            background-color: ${({ theme }) => theme.secondaryBgColor};
                        }
                    }

                    .active{
                        background-color: var(--color-main) !important;
                        color: ${({theme}) => theme.reverseMainTextColor} !important;
                        border-color: transparent ;
                    }
                }
            }


           
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
            gap: 50px;
        }
    }
`

const AddFerryPricesModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const [message, setMessage] = useState("")
    const [isSubmited, setIsSubmitted] = useState(false)

    const { lockScroll, unlockScroll } = useScrollLock();
    const {modalLocation } = useSelector(state => state.modal)

    const {feribotUcretList} = useSelector(state => state.calc)

    const [selectedFeribot, setSelectedFeribot] = useState(null)
    const [selectedAracType, setSelectedAracType] = useState(null)
    const [selectedYon, setSelectedYon] = useState(null)

    //! bu apiden gelen datanın unique olarak filterlenmiş hali 
    const [feribotList, setFeribotList] = useState([])

    //! bu seçilen köprüye göre apiden gelen datanın filterlenmiş hali 
    const [aracTipiList, setAracTipiList] = useState([])

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])
    

    useEffect(() => {
        if(feribotUcretList){
            const list = feribotUcretList.map(item => item.seferIsmi)
            setFeribotList([...new Set(list)])
         }
    },[feribotUcretList])

    useEffect(() => {
        if(selectedFeribot) {
            const list = feribotUcretList.filter((item) => {
                return item.seferIsmi === selectedFeribot
            }).sort((a,b) => a.aracTipi - b.aracTipi)

            setAracTipiList(list)
        }
    },[selectedFeribot])


    useEffect(() => {
        if(isSubmited){
            if(selectedFeribot && selectedAracType){
                setMessage("")
            }
            else{
                setMessage("Lütfen feribot ve araç tipini seçiniz.")
            }
        }
    },[isSubmited, selectedFeribot, selectedAracType])

    const handleSubmit = () => {
        setIsSubmitted(true)
        if(!selectedFeribot || !selectedAracType){
            setMessage("Lütfen feribot ve araç tipini seçiniz.")
        }
        else{
            //! bu selectedAracType aslında bir object olduğu için direk bunu verebiliriz.
            const {id, seferIsmi, aracTipi } = selectedAracType
            const ucret = selectedYon === "tek" ? selectedAracType.tekYon : selectedAracType.ciftYon 
            dispatch(updateCurrentFerryList({id, seferIsmi, aracTipi, ucret}))
            dispatch(showModal(null))
        }
    }


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Feribot Ekle"}/>
        <div className="content">
            <div className="side">
                <h4 className="title">Feribot Seçiniz</h4>
                <div className="list">
                    {
                        feribotList.map((item) =>(
                            <div onClick={() => {setSelectedFeribot(item); setSelectedAracType(null)}} className={selectedFeribot === item ? "active item": "item" }>
                                {item === "IDOESKİHİSAR" && "İDO-ESKİHİSAR-TOPÇULAR"}
                                {item === "NEGMARESKİHİSAR" && "NEGMAR-ESKİHİSAR-TAVŞANLI"}
                                {item === "TRAMOLABANDIRMA" && "TRAMOLA-BANDIRMA-AMBARLI"}
                            </div>
                        ))
                    }
                </div>
            </div>
            {
                selectedFeribot &&
                <div className="side">
                    <h4 className="title">Araç Tipi Seçiniz</h4>
                    <div className="list">
                        {
                            aracTipiList.map((item) =>(
                                <div onClick={() => {setSelectedAracType(item); setSelectedYon(null)}} className={selectedAracType?.id === item.id ? "active item": "item" }>{item.aracTipi}</div>
                            ))
                        }
                    </div>

                </div>
            }

            {
                selectedAracType &&
                <div className="side">
                    <h4 className="title">Tek/Çift Yön Seçiniz</h4>
                    <div className="list">
                        <div onClick={() => setSelectedYon("tek")} className={selectedYon === "tek" ? "active item": "item" }>Tek Yön</div>
                        <div onClick={() => setSelectedYon("cift")} className={selectedYon === "cift" ? "active item": "item" }>Çift Yön</div>
                    </div>
                </div>
            }
        </div>
        {
            message &&
            <div>{message}</div>
        }
        <div className='button-grp'>
            <Button color={"#F4F4F4"} background={"#0EAC00"} width="220px" radius={"10px"} text={"Ekle"} padding="0 10px" handleClick={handleSubmit}/>
            <Button color={"#F4F4F4"} background={"#FF0000"} width="220px" radius={"10px"} text={"Vazgeç"} padding="0 10px" handleClick={()=> dispatch(showModal(null))}/>
        </div>
    </div>
</ModalContainer>
  )
}

export default AddFerryPricesModal